@if (instruction$ | async; as instruction) {
  <elder-pane class="full">
    <elder-pane-header>
      <elder-pane-title>{{ 'instructions.instruction' | translate }}</elder-pane-title>
      <elder-pane-actions>
        <button
          mat-icon-button
          matBadge="!"
          matBadgeColor="warn"
          [matBadgeHidden]="mainFrm.form.valid"
          [disabled]="!mainFrm.form.valid"
          (click)="onSave($event)"
        >
          <mat-icon>save</mat-icon>
        </button>
      </elder-pane-actions>
    </elder-pane-header>
    <elder-pane-content>
      <form #mainFrm="ngForm" class="flex layout-row gap-xl">
        <div class="flex layout-col gap-xl">
          <elder-pane-subtitle>{{ 'context.general' | translate }}</elder-pane-subtitle>
          <!-- Task name -->
          <div class="layout-col">
            <mat-form-field class="flex">
              <mat-label>{{ 'context.name' | translate }}</mat-label>
              <input
                matInput
                type="text"
                name="name"
                [(ngModel)]="instruction.taskName"
                placeholder="{{ 'context.name' | translate }}"
              />
            </mat-form-field>
          </div>
          <!-- Task description -->
          <div class="layout-col">
            <mat-form-field class="flex">
              <mat-label>{{ 'context.description' | translate }}</mat-label>
              <input
                matInput
                type="text"
                name="description"
                [(ngModel)]="instruction.taskDescription"
                placeholder="{{ 'context.description' | translate }}"
              />
            </mat-form-field>
          </div>
          <elder-pane-subtitle>{{ 'attachments.specs.title' | translate }}</elder-pane-subtitle>
          <elder-card-organizer
            class="flex"
            [autoMoveCards]="true"
            [organizerModel]="cardData"
            (requestNewCard)="onNewAttachmentSpecCard($event)"
          >
            <div
              *elderStackCard="let attSpec; let i = index"
              class="flex layout-row gap-lg place-start-center"
            >
              <app-attachment-spec-detail class="flex" [attachment]="attSpec">
              </app-attachment-spec-detail>
            </div>
          </elder-card-organizer>
        </div>
      </form>
    </elder-pane-content>
  </elder-pane>
}
